import crypto from 'node:crypto'
import type { EnvSection } from '@cli-types/core-engine/env.js'
import { DATABASE_URL_PLACEHOLDER } from '@cli-constants/scaffolding.js'

export function getCoreEnvSections(
  databaseUrl: string | undefined,
  devPort: number,
  namespace: string
): EnvSection[] {
  const authSecret = crypto.randomBytes(32).toString('base64')
  return [
    {
      header: 'Database (PostgreSQL)',
      vars: [{ key: 'DATABASE_URL', value: databaseUrl ?? DATABASE_URL_PLACEHOLDER }]
    },
    {
      header: 'Authentication',
      vars: [
        { key: 'BETTERSTART_AUTH_SECRET', value: authSecret },
        { key: 'BETTERSTART_AUTH_URL', value: `http://localhost:${devPort}` },
        { key: 'BETTERSTART_AUTH_BASE_PATH', value: `/api/${namespace}/auth` }
      ]
    }
  ]
}
